import React from 'react';
import styled from 'styled-components';
import { fontWeightMedium } from '@bufferapp/ui/style/fonts';
import { HC_UTM_PARAMS } from '~/utils/contants';

export const URLS = {
  SIGN_UP_URL: 'https://buffer.com/pricing/publish',
  SUPPORT_URL: `https://support.buffer.com/hc/en-us/articles/360063417793?${HC_UTM_PARAMS}`,
  MARKETING_URL: 'https://buffer.com/publish',
  CONTACT_SUPPORT_URL: `https://support.buffer.com/hc/en-us/requests/new?${HC_UTM_PARAMS}`,
};

const BoldText = styled.span`
  font-weight: ${fontWeightMedium};
`;

const getContent = ({
  switchOrganization,
  translations,
  orgName,
  orgNameWithAccess,
  orgIdWithAccess,
}) => {
  const { adminWithOrgAccess, nonAdminWithOrgAccess, admin, nonAdmin } =
    translations.accessTypes;
  return {
    admin: {
      primaryAction: {
        label: admin.primaryLabel,
        onClick: () => window.location.assign(URLS.SIGN_UP_URL),
      },
      secondaryAction: {
        label: admin.secondaryLabel,
        onClick: () => window.location.assign(URLS.MARKETING_URL),
      },
      description: (
        <>
          {admin.description1}
          <BoldText>{` ${orgName} `}</BoldText>
          {admin.description2}
        </>
      ),
    },
    adminWithOrgAccess: {
      primaryAction: {
        label: `${adminWithOrgAccess.primaryLabel} ${orgNameWithAccess}`,
        onClick: () => switchOrganization(orgIdWithAccess),
      },
      secondaryAction: {
        label: adminWithOrgAccess.secondaryLabel,
        onClick: () => window.location.assign(URLS.SIGN_UP_URL),
      },
      description: (
        <>
          {adminWithOrgAccess.description1}
          <BoldText>{` ${orgName} `}</BoldText>
          {adminWithOrgAccess.description2}
          <BoldText>{` ${orgNameWithAccess} `}</BoldText>
          {adminWithOrgAccess.description3}
        </>
      ),
    },
    nonAdmin: {
      secondaryAction: {
        label: nonAdmin.secondaryLabel,
        onClick: () => window.location.assign(URLS.CONTACT_SUPPORT_URL),
      },
      description: (
        <>
          {nonAdmin.description1}
          <BoldText>{` ${orgName} `}</BoldText>
          {nonAdmin.description2}
        </>
      ),
    },
    nonAdminWithOrgAccess: {
      primaryAction: {
        label: `${nonAdminWithOrgAccess.primaryLabel} ${orgNameWithAccess}`,
        onClick: () => switchOrganization(orgIdWithAccess),
      },
      secondaryAction: {
        label: nonAdminWithOrgAccess.secondaryLabel,
        onClick: () => window.location.assign(URLS.SUPPORT_URL),
      },
      description: (
        <>
          {nonAdminWithOrgAccess.description1}
          <BoldText>{` ${orgName} `}</BoldText>
          {nonAdminWithOrgAccess.description2}
          <BoldText>{` ${orgNameWithAccess} `}</BoldText>
          {nonAdminWithOrgAccess.description3}
        </>
      ),
    },
  };
};

const getAccessType = ({ isAdmin, hasOrgWithAccess }) => {
  if (isAdmin) {
    return hasOrgWithAccess ? 'adminWithOrgAccess' : 'admin';
  }
  return hasOrgWithAccess ? 'nonAdminWithOrgAccess' : 'nonAdmin';
};

export const getTypeContent = ({
  switchOrganization,
  translations,
  isAdmin,
  orgWithAccess,
  orgName,
}) => {
  const accessType = getAccessType({
    isAdmin,
    hasOrgWithAccess: !!orgWithAccess,
  });
  const content = getContent({
    switchOrganization,
    translations,
    orgName,
    orgNameWithAccess: orgWithAccess?.name,
    orgIdWithAccess: orgWithAccess?.id,
  });
  return content[accessType];
};
